import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { useModal } from "@/lib/hooks/useModal";
import { createPortal } from "react-dom";

import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

const modalRoot = document.querySelector("#modal-root") as HTMLElement;

const Modal: React.FC<{}> = () => {
    let { children, closeModal, modal, title } = useModal();

    const el = useRef(document.createElement("div"));

    useEffect(() => {
        // Use this in case CRA throws an error about react-hooks/exhaustive-deps
        const current = el.current;

        // We assume `modalRoot` exists with '!'
        modalRoot!.appendChild(current);
        //return () => void modalRoot!.removeChild(current);
    }, []);

    return createPortal(<Transition appear show={modal} as={Fragment}>
        <Dialog
            as="div"
            className="fixed inset-x-0 bottom-0 z-40 overflow-y-auto"
            onClose={() => closeModal()}
        >
            <div className="min-h-screen px-0 text-center">
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75" />
                </Transition.Child>

                <span
                    className="inline-block h-screen max-w-xl align-bottom md:align-middle"
                    aria-hidden="true"
                >
                    &#8203;
                </span>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <div className="inline-block w-full max-w-xl px-4 pb-4 space-y-3 overflow-hidden text-left align-middle transition-all bg-white rounded-lg shadow-xl">
                        <div className="flex items-center justify-between pt-4">
                            <div className="flex select-none items-center justify-center py-1 space-x-1.5 text-md text-gray-500">
                                <span>{title}</span>
                            </div>
                            <div className="inline-flex items-center justify-center p-2 text-gray-500 bg-gray-100 border border-gray-100 rounded-full cursor-pointer hover:scale-110 hover:border-gray-200" onClick={() => closeModal()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                            </div>
                        </div>
                        <div className="space-y-3 max-h-[80vh] overflow-y-auto">
                            {children}
                        </div>
                    </div>
                </Transition.Child>
            </div>
        </Dialog>
    </Transition>, el.current);
};

export default Modal;